export { default }from './Banner';
